import { react2panel } from 'common/util/react2panel';
import { QueryBlockReact } from 'common/query-builder/query-block/index';
export const QueryBlockEl = react2panel("mp-query-block", QueryBlockReact);